export default "__VITE_ASSET__DaYmGtDa__"